import styled from 'styled-components';

import {
  colorWhite,
  colorBlueGray,
  colorGray,
  colorSecondaryLighten10,
  colorSecondaryLighten95,
  colorSecondary,
  mediaQueryMobileMin,
  mediaQueryLaptopMin,
} from 'styles';

export const Wrapper = styled.div`
  width: 100%;

  @media ${mediaQueryMobileMin} {
    width: auto;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  position: relative;
  font-size: 12px;
  line-height: 14px;
  padding: 8px 8px;
  border: 1px solid ${colorBlueGray};
  background-color: ${colorWhite};
  color: ${colorGray};
  white-space: nowrap;

  &:after {
    content: '';
    position: absolute;
    top: -9px;
    bottom: -9px;
    left: -1px;
    right: -1px;
    z-index: 1;
  }

  @media ${mediaQueryLaptopMin} {
    &:after {
      display: none;
    }
  }

  &:first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  &:not(:first-child) {
    margin-left: -1px;
  }

  &:hover,
  &.focus-visible {
    background-color: ${colorSecondaryLighten95};
    border-color: ${colorSecondary};
    color: ${colorSecondary};
    z-index: 1;
  }

  ${props => {
    if (props.isChecked) {
      return `
        background-color: ${colorSecondary};
        color: ${colorWhite};
        border-color: ${colorSecondary};
        z-index: 1;

        &:hover,
        &.focus-visible {
          background-color: ${colorSecondaryLighten10};
          border-color: ${colorSecondaryLighten10};
          color: ${colorWhite};
        }
      `;
    }

    return '';
  }}
`;

export const Group = styled.div`
  display: flex;
`;
